import { render, staticRenderFns } from "./SuperAdminPasswordUpdateSuccess.vue?vue&type=template&id=451642ba&scoped=true&"
import script from "./SuperAdminPasswordUpdateSuccess.vue?vue&type=script&lang=js&"
export * from "./SuperAdminPasswordUpdateSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminPasswordUpdateSuccess.vue?vue&type=style&index=0&id=451642ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451642ba",
  null
  
)

export default component.exports